export enum Auths {
    KC = 'keycloak',
    Auth0 = 'auth0'
}